import { render, staticRenderFns } from "./CustomersFiltersModal.vue?vue&type=template&id=f67b9d46&"
import script from "./CustomersFiltersModal.vue?vue&type=script&lang=js&"
export * from "./CustomersFiltersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports